import { DATA_POSITIONING_ESCAPED, DATA_POSITIONING_HIDDEN, DATA_POSITIONING_INTERSECTING, DATA_POSITIONING_PLACEMENT } from '../constants';
/**
 * Writes all container element position updates after the position is computed
 */

export function writeContainerUpdates(options) {
  var _a, _b;

  const {
    container,
    placement,
    middlewareData,
    strategy,
    lowPPI,
    coordinates: {
      x,
      y
    }
  } = options;

  if (!container) {
    return;
  }

  container.setAttribute(DATA_POSITIONING_PLACEMENT, placement);
  container.removeAttribute(DATA_POSITIONING_INTERSECTING);

  if (middlewareData.intersectionObserver.intersecting) {
    container.setAttribute(DATA_POSITIONING_INTERSECTING, '');
  }

  container.removeAttribute(DATA_POSITIONING_ESCAPED);

  if ((_a = middlewareData.hide) === null || _a === void 0 ? void 0 : _a.escaped) {
    container.setAttribute(DATA_POSITIONING_ESCAPED, '');
  }

  container.removeAttribute(DATA_POSITIONING_HIDDEN);

  if ((_b = middlewareData.hide) === null || _b === void 0 ? void 0 : _b.referenceHidden) {
    container.setAttribute(DATA_POSITIONING_HIDDEN, '');
  }

  Object.assign(container.style, {
    transform: lowPPI ? `translate(${x}px, ${y}px)` : `translate3d(${x}px, ${y}px, 0)`,
    position: strategy
  });
}
//# sourceMappingURL=writeContainerupdates.js.map